export default __webpack_public_path__ + "static/media/work-crosstab-file@2x.4ae9fb27.svg";